import EventBus from '@/vue/events/event-bus'
import DateFilter from '@/vue/filters/date'
import moment from 'moment'
import {validateSpecialRBTimer} from '@/js/common/rb-timer'

import {
    mapGetters,
} from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'sportAllBetLang',
      'account'
    ]),
  },
  data () {
    return {
      teamA: 'oddsa',
      teamB: 'oddsb',
      teamHome: 'h',
      teamAway: 'a',
      teamDraw: 'd',
      ftPlyType: '1',
      firstHtPlyType: '2',
      secondHtPlyType: '19',
      setHandicapPlyType: '3',
      pointHdpPlyType: '4',
      iotPlyType: '5',
      gameHdpPlyType: '6',
      firstSetPlyType: '7',
      secondSetPlyType: '8',
      thirdSetPlyType: '9',
      fourthSetPlyType: '10',
      fifthSetPlyType: '11',
      sixthSetPlyType: '12',
      game1PlyType: '14',
      game2PlyType: '15',
      game3PlyType: '16',
      game4PlyType: '17',
      game5PlyType: '18',
      first5InningsPlyType: '13',
      first3InningsPlyType: '20',
      firstInningsPlyType: '21',
      secondInningsPlyType: '22',
      thirdInningsPlyType: '23',
      fourthInningsPlyType: '24',
      fifthInningsPlyType: '25',
      sixthInningsPlyType: '26',
      seventhInningsPlyType: '27',
      eighthInningsPlyType: '28',
      ninthInningsPlyType: '29',
      OTPlyType: '30',
      hdpBetType: '1',
      ouBetType: '2',
      oeBetType: '3',
      onex2BetType: '4',
      tgBetType: '5',
      htftBetType: '6',
      csBetType: '7',
      rhdpBetType: '8',
      rouBetType: '9',
      roeBetType: '10',
      ronex2BetType: '11',
      mlBetType: '12',
      rmlBetType: '13',
      otrBetType: '14',
      rcsBetType: '16',
      rhtftBetType: '17',
      rtgBetType: '18',
      dbchBetType: '19',
      rdbchBetType: '20',
      oddsToggle: true,
      rbettype : ['8','9','10','11','13','16','17','18','20','27','29','31','33','35','37','39','41','43','45','47','49','51','55','56','58','61','64','66','69','71','73','75','78','79','81','83'],
      hdpbettype: ['1','2','8','9'],
      normalHdpBettype: ['1', '8'],
      ouHdpBettype: ['2','9','46','47','48','49','80','81','82','83'],
      sportWithML: [3,7,12,13,14,15,21],
      h1x2BetType: '21',
      wdBetType: '25',
      rh1x2BetType: '27',
      hmgBetType: '28',
      rhmgBetType: '29',
      hmg1x2BetType: '30',
      rhmg1x2BetType: '31',
      bttsBetType: '32',
      rbttsBetType: '33',
      cshBetType: '34',
      rcshBetType: '35',
      twtnBetType: '36',
      rtwtnBetType: '37',
      twfbBetType: '38',
      rtwfbBetType: '39',
      twehBetType: '40',
      rtwehBetType: '41',
      twbhBetType: '42',
      rtwbhBetType: '43',
      tsbhBetType: '44',
      rtsbhBetType: '45',
      htgBetType: '46',
      rhtgBetType: '47',
      atgBetType: '48',
      ratgBetType: '49',
      wmBetType: '50',
      rwmBetType: '51',
      flgBetType: '52',
      hldsBetType: '53',
      aldsBetType: '54',
      rhldsBetType: '55',
      raldsBetType: '56',
      nogBetType: '57',
      rnogBetType: '58',
      dualBetType: ['59','73','60','61','62','63','64','65','66','67','68','69','70','71','72'],
      dualHdpBetType: ['59','73','60','61','62','63','64','68','69'],
      ouoeBetType: '59',
      rouoeBetType: '73',
      oubttsBetType: '60',
      roubttsBetType: '61',
      ouftsBetType: '62',
      // rouftsBetType: '',
      onex2ouBetType: '63',
      ronex2ouBetType: '64',
      onex2bttsBetType: '65',
      ronex2bttsBetType: '66',
      onex2ftsBetType: '67',
      // ronex2ftsBetType: '',
      dcouBetType: '68',
      rdcouBetType: '69',
      dcbttsBetType: '70',
      rdcbttsBetType: '71',
      dcftsBetType: '72',
      // rdcftsBetType: '',
      edgBetType: '74',
      exiBetType: '76',
      wmrBetType: '77',
      rwmrBetType: '78',
      rexiBetType: '79',
      htrBetType: '80',
      rhtrBetType: '81',
      atrBetType: '82',
      ratrBetType: '83',
    }
  },
  mounted() {
    this.checkInPly()    
    EventBus.$on('marketChange', ((params) => {
      this.checkInPly()
    }).bind(this))
  },
  methods: {
    checkPersian(langsCap) {
      if(window._langid!='10'){
        return '';
      }
      if(!this.$options.filters.isPersian(langsCap)){
        return 'directionltr';
      }

      return '';
    },
    getDecimalDisplay(value) {
      if(this.$store.getters.account.oddsType=='am'){
        return parseFloat(value).toFixed(0);
      }
      return parseFloat(value).toFixed(2);
    },
    commasAmount(amount) {
      amount += '';
      var x = amount.split('.');
      var x1 = x[0];
      var x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
      }
      return x1 + x2;
    },
    checkInPly() {
      if (this.$store.getters.int_marketToggle == this.$store.getters.market.inPlayMarket.key) {
        this.hdpBetType = _.cloneDeep(this.rhdpBetType)
        this.ouBetType = _.cloneDeep(this.rouBetType)
        this.oeBetType = _.cloneDeep(this.roeBetType)
        this.onex2BetType = _.cloneDeep(this.ronex2BetType)
        this.mlBetType = _.cloneDeep(this.rmlBetType)
        this.htgBetType = _.cloneDeep(this.rhtgBetType)
        this.atgBetType = _.cloneDeep(this.ratgBetType)
        this.bttsBetType = _.cloneDeep(this.rbttsBetType)
        this.wmBetType = _.cloneDeep(this.rwmBetType)
        this.twtnBetType = _.cloneDeep(this.rtwtnBetType)
        this.twfbBetType = _.cloneDeep(this.rtwfbBetType)
        this.twehBetType = _.cloneDeep(this.rtwehBetType)
        this.twbhBetType = _.cloneDeep(this.rtwbhBetType)
        this.tsbhBetType = _.cloneDeep(this.rtsbhBetType)
        this.cshBetType = _.cloneDeep(this.rcshBetType)
        this.h1x2BetType = _.cloneDeep(this.rh1x2BetType)
        this.hmgBetType = _.cloneDeep(this.rhmgBetType)
        this.hmg1x2BetType = _.cloneDeep(this.rhmg1x2BetType)
        this.hldsBetType = _.cloneDeep(this.rhldsBetType)
        this.aldsBetType = _.cloneDeep(this.raldsBetType)
        this.nogBetType = _.cloneDeep(this.rnogBetType)
        this.ouoeBetType = _.cloneDeep(this.rouoeBetType)
        this.oubttsBetType = _.cloneDeep(this.roubttsBetType)
        // this.ouftsBetType = _.cloneDeep(this.rouftsBetType)
        this.onex2ouBetType = _.cloneDeep(this.ronex2ouBetType)
        this.onex2bttsBetType = _.cloneDeep(this.ronex2bttsBetType)
        // this.onex2ftsBetType = _.cloneDeep(this.ronex2ftsBetType)
        this.dcouBetType = _.cloneDeep(this.rdcouBetType)
        this.dcbttsBetType = _.cloneDeep(this.rdcbttsBetType)
        this.exiBetType = _.cloneDeep(this.rexiBetType)
        this.wmrBetType = _.cloneDeep(this.rwmrBetType)
        this.htrBetType = _.cloneDeep(this.rhtrBetType)
        this.atrBetType = _.cloneDeep(this.ratrBetType)
        // this.dcftsBetType = _.cloneDeep(this.rdcftsBetType)
      } else {
        this.hdpBetType = '1'
        this.ouBetType = '2'
        this.oeBetType = '3'
        this.onex2BetType = '4'
        this.mlBetType = '12'
        this.htgBetType = '46'
        this.atgBetType = '48'
        this.bttsBetType = '32'
        this.wmBetType = '50'
        this.twtnBetType = '36'
        this.twfbBetType = '38'
        this.twehBetType = '40'
        this.twbhBetType = '42'
        this.tsbhBetType = '44'
        this.cshBetType = '34'
        this.h1x2BetType = '21'
        this.hmgBetType = '28'
        this.hmg1x2BetType = '30'
        this.hldsBetType = '53'
        this.aldsBetType = '54'
        this.nogBetType = '57'
        this.ouoeBetType = '59'
        this.oubttsBetType = '60'
        this.ouftsBetType = '62'
        this.onex2ouBetType = '63'
        this.onex2bttsBetType = '65'
        this.onex2ftsBetType = '67'
        this.dcouBetType = '68'
        this.dcbttsBetType = '70'
        this.dcftsBetType = '72'
        this.exiBetType= '76'
        this.wmrBetType= '77'
        this.htrBetType= '80'
        this.atrBetType= '82'
      }
    },
    checkOd(event,bettype, playtype, type){
      if(Object.keys(event.od).length == 0 || event.od[playtype][bettype] == undefined || event.od[playtype][bettype][type] <= 1){
          return false
      }
      return true
    },
    checkMmOd(event,bettype,playtype,type){
      if(Object.keys(event.od).length == 0 ||event.od[playtype][bettype] == undefined || event.od[playtype][bettype][Object.keys(event.od[playtype][bettype])] == undefined || event.od[playtype][bettype][Object.keys(event.od[playtype][bettype])][type] <= 1){
        return false
      }
      return true
    },
    validateOddHdp(args) {
      //odds, bettype, oddtype
      //ah, rah, ou, rou
      var ahou = [1, 8, 2, 9, 46, 47, 48, 49, 81, 80, 82, 83]
      var rahrou = [2, 9, 47, 49, 81, 80, 82, 83]
      var oeroe = [3, 10]
      var oddtype1 = ['my', 'in']
      var oddtype2 = ['hk', 'in', 'eu']

      if( args.odds == 0 ) {
        return false
      }
      if(oddtype1.indexOf(args.oddstype) == -1){
        if (ahou.indexOf(args.bettype) != -1) {
          if (args.oddstype == 'eu') {
            if (args.odds <= 1) {
              return false
            }
          }
          else if (args.oddstype == 'hk') {
            if (args.odds <= 0) {
              return false
            }
          }
          if (rahrou.indexOf(args.bettype, [2, 9, 46, 47, 48, 49, 81, 80, 82, 83]) != -1) {
            if(args.hdp){
              if (Math.abs(args.hdp) == 0) {
                return false
              }
            }
          }
        }
        //oe, roe
        else if (oeroe.indexOf(args.bettype) != -1) {
          if (oddtype2.indexOf(args.oddstype) != -1 && args.odds <= 1) {
            return false
          }
        }
        else {
          if (args.odds <= 1 && args.oddstype!="am") {
            return false
          }
        }
      }
      return true
    },
    toggleDisplay(){
        if(this.oddsToggle == true){
            this.oddsToggle = false
        }else{
            this.oddsToggle = true
        }
    },
    validateRBTimer(event) {
      
      if(event.rbinfo.tlsec == -1){
        return false
      }
      var timerMin = moment.duration(event.rbinfo.tlsec,'seconds').minutes()
      var timerHour = moment.duration(event.rbinfo.tlsec,'seconds').hours()
      
      if(validateSpecialRBTimer(event, timerHour, timerMin)) {
        return '2'
      }
      else if (event.rbinfo.htst == '1') {
        return '1'
      }
      else if (event.rbinfo.htst == '2') {
        return '2'
      }

      return false;
    },
    specialLeagueCaption(event, bettype) {
      var retCapt = ''
      //if(bettype == this.ouBetType || bettype == this.oeBetType || bettype == this.hdpBetType) {
        if( event.spcapt ) {
          retCapt = event.spcapt + ' - '
        }
      //}

      return retCapt
    },
    getOdd1x2UniqueId (event,playtype,bettype,team) {
      if(team == 'x'){
        team = 'd'
      }
      return event.eveid + playtype + bettype + team
    },
    getOdd1x2UniqueId_1(event,team) {
      return event.eveid + team
    },
    getOddUniqueId (event,playtype,bettype,team,dual) {
      return event.eveid + playtype + bettype + dual + team
    },
    getOtrUniqueId (event,playtype,bettype,team) {
      return event.eveid + playtype + bettype + team
    },
    oddsTeamTitle(team) {
      var retCapt = ''

      retCapt = team + ' - '

      return retCapt
    },
    checkEventPlyTypIndex(event, plytyp) {
      var firstindex = false
      if(typeof event.od != 'undefined' ){
        if(typeof event.od[plytyp] != 'undefined' ) {
          var index = Object.keys(event.od).indexOf(plytyp)
          if(index==0){
            firstindex = true
          }
        }
      }
      return firstindex
    },
    checkOddValidation(value) {
      if(this.$store.getters.account.oddsType=='am'){
        var pass_value= parseFloat(value);
        if(pass_value<0){
          pass_value=Math.abs(100/pass_value);
        }else{
          pass_value=pass_value/100;
        }
        pass_value=pass_value.toFixed(3);
        if(pass_value<=0){
          return false;
        }
      }else{
        if(parseFloat(value)<=1){
          return false;
        }
      }
      return true;
    },
    checkOdds(val) {
      if(this.$store.getters.account.oddsType=='am'){
        if(val < 0){
          return parseFloat(Math.abs(100/val))+1
        }else{
          return parseFloat(Math.abs(val/100))+1
        }
      }
      return parseFloat(val)
    },
  },
  beforeDestroy() {
    EventBus.$off('marketChange')
  },
}



// WEBPACK FOOTER //
// ./resources/score/vue/mixins/allBet.js